// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"766725a9","404":"4556ec7a","440":"7595a00d","468":"49230842","682":"bf099a95"}[chunkId] + ".chunk.css";
};